import { GlAlert, GlButton, GlKeysetPagination, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import EMPTY_SVG_URL from '@gitlab/svgs/dist/illustrations/empty-state/empty-ai-catalog-md.svg?url';
import { __, s__ } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
import ConfirmActionModal from '../../../../../../../app/assets/javascripts/vue_shared/components/confirm_action_modal.vue?vue3';
import ResourceListsEmptyState from '../../../../../../../app/assets/javascripts/vue_shared/components/resource_lists/empty_state.vue?vue3';
import AiCatalogListItem from './ai_catalog_list_item.vue?vue3';
import AiCatalogListSkeleton from './ai_catalog_list_skeleton.vue';
export default {
    name: 'AiCatalogList',
    components: {
        GlAlert,
        AiCatalogListItem,
        AiCatalogListSkeleton,
        ConfirmActionModal,
        GlButton,
        GlKeysetPagination,
        GlSprintf,
        ResourceListsEmptyState
    },
    directives: {
        SafeHtml
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        pageInfo: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        itemTypeConfig: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        disableConfirmTitle: {
            type: String,
            required: false,
            default: undefined
        },
        disableConfirmMessage: {
            type: String,
            required: false,
            default: undefined
        },
        disabledItemTypeMessages: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        disableFn: {
            type: Function,
            required: false,
            default: undefined
        },
        search: {
            type: String,
            required: false,
            default: ''
        },
        emptyStateTitle: {
            type: String,
            required: true
        },
        emptyStateDescription: {
            type: String,
            required: false,
            default: null
        },
        emptyStateButtonHref: {
            type: String,
            required: false,
            default: null
        },
        emptyStateButtonText: {
            type: String,
            required: false,
            default: null
        },
        emptyStateButtonTrackingLabel: {
            type: String,
            required: false,
            default: null
        },
        emptyStatePrimaryButtonText: {
            type: String,
            required: false,
            default: null
        },
        emptyStatePrimaryButtonHref: {
            type: String,
            required: false,
            default: null
        },
        emptyStatePrimaryButtonTrackingLabel: {
            type: String,
            required: false,
            default: null
        },
        emptyStateTrackingEvent: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'empty-state-click',
        'next-page',
        'prev-page'
    ],
    data () {
        return {
            itemToDisable: null
        };
    },
    computed: {
        hasActionItems () {
            return Boolean(this.itemTypeConfig.disableActionItem || this.itemTypeConfig.actionItems);
        },
        disableActionText () {
            return this.itemTypeConfig.disableActionItem?.text || __('Disable');
        },
        hasPrimaryButton () {
            return Boolean(this.emptyStatePrimaryButtonText);
        },
        exploreButtonVariant () {
            return this.hasPrimaryButton ? 'default' : 'confirm';
        }
    },
    methods: {
        async disableItem () {
            await this.disableFn?.(this.itemToDisable);
            this.itemToDisable = null;
        }
    },
    i18n: {
        searchScopeHint: s__('AICatalog|Search matches names and descriptions only. Project, visibility and item type are not searched.')
    },
    EMPTY_SVG_URL
};
